<template>
    <div class="landing__footer" v-bind="$attrs">
        <div class="landing__footer__links">
            <div>
                <NewAppLogoSvg
                    :gradient="false" fill="#fff" width="100px" text-fill="#fff"
                    :position="widthNumber"
                />
            </div>

            <div class="grid gap-2">
                <ul class="landing__footer__list">
                    Features
                    <li v-for="item in features" :key="item.id" class="cursor-pointer">
                        <router-link :to="`/products/${item.id}`">
                            {{ item.name }}
                        </router-link>
                    </li>
                </ul>
                
                <ul class="landing__footer__list">
                    Resources
                    <li><a href="https://www.uzoamakaanyanwu.com/posts/building-ziner/overview" target="_blank">Why Ziner?</a></li>
                    <li class="cursor-pointer" @click="goToPageSection('faqs')">
                        <span href="">FAQs</span>
                    </li>
                    <li class="cursor-pointer" @click="goToPageSection('integrations')">
                        <router-link to="/products/integrations">
                            Integrations
                        </router-link>
                    </li>
                </ul>
                
                <ul class="landing__footer__list">
                    Contact
                    <li class="text--lower">
                        <p class="text--normal text--sm">
                            support@ziner.cc
                        </p>
                    </li>
                    
                    <li v-if="!isSupportPage">
                        <router-link to="/support">
                            Support page
                        </router-link>
                    </li>
                </ul>
    
                <ul class="landing__footer__list">
                    Company
                    <li v-for="item in company" :key="item.id" class="cursor-pointer">
                        <router-link :to="`/${item.id}`">
                            {{ item.name }}
                        </router-link>
                    </li>
                </ul>
    
                <ul class="landing__footer__list">
                    Legal
                    <li v-for="item in legal" :key="item.id" class="cursor-pointer">
                        <router-link :to="`/${item.id}`">
                            {{ item.name }}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>

        <div class="landing__footer__copyright">
            <p>© {{ currentYear }} Ziner. All rights reserved.</p>
            
            <!-- <div v-if="showBgToggle" class="bg__control" @click="toggleBackground">
                <span v-if="isNoisyBg" class="mr--5">Turn off noisy background</span>
                <span v-else class="mr--5">Turn on noisy background</span>
                <span v-if="isNoisyBg">
                    <svg
                        xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                        style="transform: ;msFilter:;"
                    ><path d="m5.705 3.71-1.41-1.42C1 5.563 1 7.935 1 11h1l1-.063C3 8.009 3 6.396 5.705 3.71zm13.999-1.42-1.408 1.42C21 6.396 21 8.009 21 11l2-.063c0-3.002 0-5.374-3.296-8.647zM12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm7-7.414V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.184 4.073 5 6.783 5 10v4.586l-1.707 1.707A.996.996 0 0 0 3 17v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a.996.996 0 0 0-.293-.707L19 14.586z" /></svg>
                </span>
                <span v-else>
                    <svg
                        xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                        style="transform: ;msFilter:;"
                    ><path d="M20.345 18.931A.993.993 0 0 0 21 18v-1a.996.996 0 0 0-.293-.707L19 14.586V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258c-1.323.364-2.463 1.128-3.346 2.127L3.707 2.293 2.293 3.707l18 18 1.414-1.414-1.362-1.362zM12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zM5 10v4.586l-1.707 1.707A.996.996 0 0 0 3 17v1a1 1 0 0 0 1 1h10.879L5.068 9.189C5.037 9.457 5 9.724 5 10z" /></svg>                </span>
            </div> -->
        </div>
    </div>
</template>

<script>
import NewAppLogoSvg from "../ui/logos/NewAppLogoSvg.vue";

export default {
    name: "LandingFooter",

    components: { NewAppLogoSvg },

    props: {
        showBgToggle: {
            type: Boolean,
            default: true,
        },
    },

    data(){
        return {
            currentYear: undefined,
            isNoisyBg: true,
            windowWidth: window.innerWidth,
            features: [
                { name: "Client management", id: "client-management" },
                { name: "Project management",id: "project-management" },
                { name: "Task management", id: "task-management" },
                { name: "Invoicing", id: "invoicing" },
                { name: "Appointments", id: "appointments" },
                { name: "Custom reminders", id: "reminders" },
                { name: "Time tracking", id: "time-tracking" },
                { name: "Reports", id: "reports" },
            ],
            company: [
                { name: "About", id: "about" },
                { name: "Pricing", id: "pricing" },
            ],
            legal: [
                { name: "Terms", id: "terms" },
                { name: "Privacy policy", id: "privacy-policy" },
            ],
        };
    },

    computed: {
        isSupportPage() {
            return this.$route.name === "support";
        },

        widthNumber() {
            return this.windowWidth > 992 ? "center" : "left";
        },
    },

    mounted() {
        const currentYear = new Date().getFullYear();
        this.currentYear = currentYear;
    },

    methods: {
        goToPage(val) {
            switch (val) {
            case "pricing":
                return this.$router.push("/pricing");
            
            default:
                break;
            }

            this.$store.dispatch("app/setLandingPageSectionId", val);
        },

        goToPageSection(val) {
            this.$store.dispatch("app/setLandingPageSectionId", val);
        },

        toggleBackground() {
            this.isNoisyBg = !this.isNoisyBg;
        },
    },
};
</script>